module.exports = __webpack_public_path__ + "assets/img/home-title.e7fe497e.png";